// Manage multiple drawers' open order and calculate their positions
const state = {
  openOrder: [],  // Track drawer open order: ['phone', 'text']
  widths: {
    phone: 355,
    text: 355
  }
}

const getters = {
  // Calculate right offset for each drawer
  getDrawerOffset: (state) => (drawerType) => {
    const index = state.openOrder.indexOf(drawerType);
    if (index === -1) return 0;
    
    let offset = 0;
    // Sum up widths of drawers opened after this one (to the right)
    for (let i = index + 1; i < state.openOrder.length; i++) {
      offset += state.widths[state.openOrder[i]];
    }
    return offset;
  },
  
  // Calculate z-index (later opened drawer has higher z-index)
  getDrawerZIndex: (state) => (drawerType) => {
    const index = state.openOrder.indexOf(drawerType);
    return index === -1 ? 2000 : 2000 + index;
  }
}

const mutations = {
  updateDrawerOrder(state, { drawerType, isOpen }) {
    const index = state.openOrder.indexOf(drawerType);
    if (isOpen) {
      // Remove if exists, then push to end (rightmost position)
      if (index !== -1) {
        state.openOrder.splice(index, 1);
      }
      state.openOrder.push(drawerType);
    } else {
      // Remove from array when closed
      if (index !== -1) {
        state.openOrder.splice(index, 1);
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
